import nativeFunctions from 'mobile-bridge/functions';
import { useEffect, useMemo, useState } from 'react';

export function useGeolocation() {
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [locationRequestIndex, setLocationRequestIndex] = useState(0);

  const refresh = () => {
    nativeFunctions.getLocation();
  };

  useEffect(() => {
    const handleUpdateLocation = (e) => {
      const { latitude, longitude } = e.detail || {};

      setLatitude(latitude);
      setLongitude(longitude);
      setLocationRequestIndex((new Date()).getTime());
    };

    window.addEventListener('updatelocation', handleUpdateLocation);
    return () => window.removeEventListener('updatelocation', handleUpdateLocation);
  }, []);

  return useMemo(
    () => ({
      latitude,
      longitude,
      locationRequestIndex,
      refresh,
    }),
    [latitude, longitude, locationRequestIndex],
  );
}
